import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import api from "api";
import { useStart } from "features/start/fabric";


export const query = {
	getStatus: (profileId) => ({
		queryKey: ["partner-status", profileId],
		queryFn: () => api.partner.getByProfile(profileId),
		enabled: Boolean(profileId)
	}),
	getPermission: (profileId) => ({
		queryKey: ["partner-permission"],
		queryFn: () => api.user.partnerCreation(),
		enabled: !profileId
	})
};

export const useMutatePartner = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationKey: ["partner-signup"],
		mutationFn: api.partner.create,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["start"] });
		}
	});
};

export const useQuerySignup = () => {
	const start = useStart();
	return useQuery(query.getStatus(start.profiles.partner?.id));
};

export const useQuerySignupPermission = () => {
	const start = useStart();
	return useQuery(query.getPermission(start.profiles.partner?.id));
};